import React from 'react';
import Lottie from 'react-lottie';
import AixueHeader from '@/components/AixueHeader/index';
import styles from './index.module.scss';
import phonicsBackground from '@/assets/productCenter/phonics/phonics-bg.png';
import starData from '@/assets/lottie/star-data.json';

const starLottieOptions = {
  loop: true,
  autoplay: true,
  animationData: starData,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
};

export default function Screen1() {
  return (
    <section className={styles['screen1-cover']}>
      <div
        className={styles['screen1-bg']}
        style={{ backgroundImage: `url(${phonicsBackground})` }}
        aria-hidden
      />
      <div className={styles['screen1-header']}>
        <AixueHeader title="爱学" />
      </div>

      <div className={styles['screen1-wrap']}>
        <div className={styles['screen1-content']}>
          <div
            className={`wow animate__animated animate__fadeIn ${styles['screen1-title']}`}
            style={{ animationDelay: '0.2s', animationDuration: '1.2s' }}
          >
            <div className={styles['screen1-title-row']}>
              爱学AI自然拼读
              <span className={styles['screen1-star-wrap']} aria-hidden>
                <Lottie options={starLottieOptions} />
              </span>
            </div>
          </div>
          <div
            className={`wow animate__animated animate__fadeIn ${styles['screen1-desc']}`}
            style={{ animationDelay: '0.4s', animationDuration: '1.2s' }}
          >
            爱学AI自然拼读，AI一对一英语教学产品的领先者。根据学员不同阶段特点构建全维度语言培养系统，依托强大的爱学大模型带给用户革命性交互体验，首个教育级数字人技术打造超真人一对一效果。
          </div>
        </div>
      </div>
    </section>
  );
}
